/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface OpportunityInterestResponse
 */
export interface OpportunityInterestResponse {
  /**
   *
   * @type {string}
   * @memberof OpportunityInterestResponse
   */
  agreementId: string;
  /**
   * True when the carrier already had an agreement, so nothing new was created.
   * @type {boolean}
   * @memberof OpportunityInterestResponse
   */
  alreadyRegistered: boolean;
}

/**
 * Check if a given object implements the OpportunityInterestResponse interface.
 */
export function instanceOfOpportunityInterestResponse(
  value: object,
): value is OpportunityInterestResponse {
  if (!("agreementId" in value) || value["agreementId"] === undefined)
    return false;
  if (
    !("alreadyRegistered" in value) ||
    value["alreadyRegistered"] === undefined
  )
    return false;
  return true;
}

export function OpportunityInterestResponseFromJSON(
  json: any,
): OpportunityInterestResponse {
  return OpportunityInterestResponseFromJSONTyped(json, false);
}

export function OpportunityInterestResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): OpportunityInterestResponse {
  if (json == null) {
    return json;
  }
  return {
    agreementId: json["agreementId"],
    alreadyRegistered: json["alreadyRegistered"],
  };
}

export function OpportunityInterestResponseToJSON(
  json: any,
): OpportunityInterestResponse {
  return OpportunityInterestResponseToJSONTyped(json, false);
}

export function OpportunityInterestResponseToJSONTyped(
  value?: OpportunityInterestResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    agreementId: value["agreementId"],
    alreadyRegistered: value["alreadyRegistered"],
  };
}
